import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m6.653 2.207 5.107 5.33a.664.664 0 0 1 0 .926l-5.107 5.33a.667.667 0 0 1-.946.02.666.666 0 0 1-.02-.946l4.687-4.892-4.686-4.843a.666.666 0 0 1 .02-.945.666.666 0 0 1 .945.02"
    }, null, -1)
  ]))]))
}
export default { render: render }